import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {ServiceTimeRequestsService} from "../../services/service-time-requests.service";

export class PricePlanCreateEventDialogViewComponent implements IController {
  programId: any;
  days: any;
  currentDay: any;
  query: any;

  private config: any;
  private event: any;
  private date: any;
  private isLoading: boolean;
  private isTimeSelectionCurrect: boolean;
  private startTime: any;
  private endTime: any;
  private dateSelectOptions: any;
  cancel: Function;

  constructor(private $mdDialog, private pricePlanConstant, private $stateParams,
              private serviceTimeRequestsService: ServiceTimeRequestsService, private moment, private splitService) {
    this.config = angular.copy(this.pricePlanConstant.serviceTime);
  }

  $onInit() {
    this.event = {
      slot: {
        //The following properties will be set via the UI : 'commission', 'priceExtra', 'priceFactor'
        from: 0,
        to: 1,
        enabled: this.config.createEventDefaults.isSlotEnabled
      }
    };

    this.date = {
      value: new Date(this.currentDay),
      min: new Date(this.currentDay),
      max: new Date(this.query.to)
    };
    this.isLoading = false;

    this.startTime = this.config.createEventDefaults.startTime;
    this.endTime = this.config.createEventDefaults.endTime;
    this.isTimeSelectionCurrect = true;

    this.createDateSelectOptions();
    this.changeEventColors();
    this.cancel = this.$mdDialog.cancel;
  }

  ok(form) {

    if (form) {
      form.$setSubmitted(true);

      if (form.$valid && !!this.isTimeSelectionCurrect) {
        this.event.slot.from = this.updateSlotTime(this.startTime);
        this.event.slot.to = this.updateSlotTime(this.endTime);

        const day = this.getDay(this.date.value),
          dayCopy = angular.copy(day);

        dayCopy.dayChunks.push(this.event.slot);

        this.isLoading = true;
        this.query.zoneId = this.splitService.getTimeZone();

        this.serviceTimeRequestsService.updateCreateSpecialDay(this.programId, dayCopy, this.query).then(
          (specialDays) => {

            const updatedDay = _.find(specialDays, (dayOfWeek) => {
              return _.isEqual(dayOfWeek.id, dayCopy.id);
            });

            this.$mdDialog.hide({
              specialDays: specialDays,
              updatedDay: updatedDay
            });

          }
        ).catch(error => this.$mdDialog.cancel(error));
      }
    }
  }

  getDay(date) {
    return _.find(this.days, (day) => {
      return _.isEqual(this.moment(date).date(), this.moment(day.date).date()) &&
        _.isEqual(this.moment(date).day(), this.moment(day.date).day());
    });
  }

  updateSlotTime(time) {
    const HOUR = 60,
      minutes = time.minute > 0 ? HOUR / time.minute : time.minute,
      factored = minutes > 0 ? 1 / minutes : minutes;

    return time.hour + factored;

  }

  createDateSelectOptions() {
    // create options for time select boxes (this will be removed in favor of mdDatetime picker when it becomes available).
    this.dateSelectOptions = {
      hours: [],
      minutes: []
    };

    const steps = this.pricePlanConstant.serviceTime.steps;

    //Hours
    for (let hour = 0; hour <= 23; hour = hour + steps.hour) {
      this.dateSelectOptions.hours.push(hour);
    }

    //Minutes
    for (let minute = 0; minute <= 59; minute = minute + steps.minute) {
      this.dateSelectOptions.minutes.push(minute);
    }
  }

  changeEventColors() {
    const state = this.event.slot.enabled ? this.config.events.states[3] : this.config.events.states[2],
      colorScheme = this.serviceTimeRequestsService.getEventColorScheme(true, state);
    _.merge(this.event, colorScheme);
  }

  timeValidationCheck() {
    if (this.startTime.hour >= this.endTime.hour) {
      this.isTimeSelectionCurrect = this.startTime.minute < this.endTime.minute;
    } else {
      this.isTimeSelectionCurrect = true;
    }
  }

}

angular
  .module('bringoz.admin.pricePlan')
  .component('pricePlanCreateEventDialogView', {
    bindings: {
      programId: '<',
      days: '<',
      currentDay: '<',
      query: '<'
    },
    template: require('./price-plan-create-event-dialog-view.html').default,
    controller: PricePlanCreateEventDialogViewComponent

  });
